import { ArrowRight, Quote, Star } from "lucide-react";
import { Overline } from "./Reveal";

const testimonials = [
  {
    name: "Sreehari AU",
    course: "BSc Physics",
    location: "University of Arizona, USA",
    quote:
      "Movementor Education guided me from application to admission and scholarship support for my studies in the USA. Their team made the whole process smooth, supportive, and stress-free.",
    image: "/Sreehari Aryadan Unnikrishnan(USA)-BSc Physics-University of Arizona.jpeg",
  },
  {
    name: "Nehla Shajahan",
    course: "MSc Biological & Bioprocess Engineering",
    location: "University of Sheffield, UK",
    quote:
      "All the staff were so nice and cooperative. They explained every procedure in detail and guided me throughout the entire process.",
    image: "/Nehla Shajahan-UK-MSc Biological and Bioprocess Engineering-University of Sheffield.jpeg",
  },
  {
    name: "Aswa Kumar",
    course: "MSc Engineering Management",
    location: "University of Manchester, UK",
    quote:
      "I had a great experience with Movementor. Their team handled university shortlisting, deadlines, and visa guidance with professionalism and prompt communication.",
    image: "/Aswa Kumar - University of Manchester - Msc Engineering project management - sep 26 - UK visa holder.jpeg",
  },
];

export const Testimonials = () => (
  <section
    id="testimonials"
    data-testid="testimonials-section"
    className="relative bg-[#F7F4F1] py-20 lg:py-28"
  >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="max-w-[1100px]">
        <Overline testid="testimonials-overline" className="mb-4 text-[15px] sm:text-[18px] tracking-[0.34em]">student stories</Overline>
        
        <h2
          data-testid="team-heading"
          className="mt-6 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-[#111111] max-w-2xl"
        >
          Real students. Real journeys.
        </h2>
      </div>

      <div className="mt-6 grid items-stretch gap-6 xl:grid-cols-[minmax(0,1.85fr)_440px]">
        <div className="grid gap-5 md:grid-cols-3">
          {testimonials.map((student, index) => (
            <article
              key={student.name}
              data-testid={`testimonial-card-${student.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group flex h-full flex-col justify-between rounded-[26px] border border-[#111111]/10 bg-white p-5 shadow-[0_18px_40px_rgba(17,17,17,0.04)] transition-transform duration-300 hover:-translate-y-0.5"
            >
              <div className="flex items-start justify-between">
                <Quote className="h-8 w-8 text-[#FE7815]" />
                {index < testimonials.length - 1 && (
                  <button
                    type="button"
                    aria-label="Next testimonial"
                    className="hidden h-11 w-11 items-center justify-center rounded-full border border-[#111111]/10 bg-[#FFFFFF] text-[#111111] shadow-sm md:flex"
                  >
                    <ArrowRight className="h-4 w-4" />
                  </button>
                )}
              </div>

              <p className="mt-5 text-base leading-8 text-[#111111] sm:text-lg">
                {student.quote}
              </p>

              <div className="mt-8 flex items-center gap-3 border-t border-[#111111]/5 pt-4">
                <img
                  src={student.image}
                  alt={student.name}
                  className="h-12 w-12 shrink-0 rounded-full border-2 border-[#FE7815]/20 object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-lg font-semibold text-[#111111]">{student.name}</p>
                  <p className="text-sm leading-relaxed text-[#111111]/75">{student.course}</p>
                  <p className="text-sm leading-relaxed text-[#111111]/60">{student.location}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <aside className="flex h-full flex-col justify-between rounded-[30px] border border-[#111111]/10 bg-[#F8EAE5] p-6 shadow-[0_18px_40px_rgba(17,17,17,0.04)] lg:p-8">
          <div>
            <div className="flex items-center">
              <span className="text-[3.2rem] font-black tracking-[-0.05em] text-[#4285F4]">G</span>
              <span className="text-[3.2rem] font-black tracking-[-0.05em] text-[#EA4335]">o</span>
              <span className="text-[3.2rem] font-black tracking-[-0.05em] text-[#FBBC05]">o</span>
              <span className="text-[3.2rem] font-black tracking-[-0.05em] text-[#4285F4]">g</span>
              <span className="text-[3.2rem] font-black tracking-[-0.05em] text-[#34A853]">l</span>
              <span className="text-[3.2rem] font-black tracking-[-0.05em] text-[#EA4335]">e</span>
            </div>

            <p className="mt-5 text-[1.15rem] font-medium text-[#111111]">Business Rating</p>

            <div className="mt-5 flex items-end gap-3">
              <span className="text-[4rem] font-black tracking-[-0.08em] text-[#111111] leading-none">
                4.9
              </span>
              <div className="mb-2 flex items-center gap-1 text-[#F7C948]">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-current" />
                ))}
              </div>
            </div>

            <p className="mt-4 text-base leading-7 text-[#111111]/75">
              Based on 84+ reviews from students and parents
            </p>
          </div>

          <a
            href="https://share.google/IElH4yLKcNZhsPWgd"
            target="_blank"
            rel="noreferrer"
            className="mt-8 inline-flex items-center justify-between gap-3 rounded-full border border-[#111111]/10 bg-white px-4 py-4 text-lg font-semibold text-[#111111] shadow-[0_10px_25px_rgba(17,17,17,0.08)] transition-transform duration-300 hover:-translate-y-0.5"
          >
            <span className="flex items-center gap-3">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#F1F3F4] text-[#4285F4] text-lg font-bold">
                G
              </span>
              Read our Google reviews
            </span>
            <ArrowRight className="h-5 w-5" />
          </a>
        </aside>
      </div>
    </div>
  </section>
);
